import {createContext} from 'react'

export const PaymentCalenderPageContext = createContext({
  // Calendar data
  calendarEvents: [] as any[],
  isLoadingCalendarEvents: false,
  calendarRef: null as any,

  // Filters
  filters: {} as any,
  onSearch: (search: string) => {},

  // Suppliers dropdown
  suppliersList: [] as any[],
  isLoadingSuppliers: false,

  // Calendar navigation
  updateCalendarMonth: (range: any) => {},
  onApplyCalendarFilters: (data: any) => {},
  resetCalendarFilters: () => {},
  setViewDateRange: (range: string) => {},
  setIsCurrentDateIsInView: (isInView: boolean) => {},
  viewDateRange: '',
  isCurrentDateIsInView: true,

  // Modal state
  selectedDate: null as Date | null,
  setSelectedDate: (date: Date | null) => {},

  // List view state
  currentView: 'list' as 'list' | 'calendar',
  setCurrentView: (view: 'list' | 'calendar') => {},

  // Payment List Data
  paymentListData: [] as any[],
  paymentListFilters: {} as any,
  isLoadingPaymentListData: false,
  paymentListPagination: {} as any,
  onPaymentListPageChange: (page: number) => {},
  onPaymentListSortingChange: (field: string, direction: 'asc' | 'desc') => {},
  onApplyPaymentListFilters: (data: any) => {},
  resetPaymentListFilters: () => {},
})
